import type ISchoolDirectoryRepository from '@/core/domain/school/directory/ISchoolDirectoryRepository.ts'
import SchoolDirectoryEntry from '@/core/domain/school/directory/SchoolDirectoryEntry.ts'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory.ts'

export default class SchoolDirectoryRepository implements ISchoolDirectoryRepository {
  /**
   * Fetch all entry corresponding to the given code UAI
   * @param codeUai
   */
  async fetchByCodeUai(codeUai: string): Promise<SchoolDirectoryEntry | null> {
    const response = await apiService.get(`admin/schools/directory/${codeUai}`)
    if (!Array.isArray(response.data)) {
      throw new Error('Expected array response for schools')
    }

    if (response.data.length > 1) {
      throw new Error('Expected only one entry for the given code UAI')
    }

    const [entry] = response.data
    return entry ? SchoolDirectoryEntry.create(entry) : null
  }
}